import { canonicalOrderStatusKey } from './orderAdminTransitions';

const GRANULARITY_MAP = {
  day: 'daily',
  month: 'monthly',
  year: 'yearly',
};

export function mapGranularity(byTime) {
  return GRANULARITY_MAP[byTime] || 'daily';
}

export function normalizeReportParams(params = {}) {
  return Object.entries(params).reduce((acc, [key, value]) => {
    if (value === undefined || value === null || value === '') return acc;
    acc[key] = value;
    return acc;
  }, {});
}

export function buildBaseReportParams({
  date_from,
  date_to,
  by_time,
  ...rest
} = {}) {
  return normalizeReportParams({
    startDate: date_from,
    endDate: date_to,
    granularity: mapGranularity(by_time),
    ...rest,
  });
}

/** Products report: map UI filters to API keys (camel + snake aliases). */
export function buildProductsReportParams({
  date_from,
  date_to,
  by_time,
  categoryId,
  productId,
  sort,
  sortDir,
  search,
  page,
  perPage,
} = {}) {
  const base = buildBaseReportParams({ date_from, date_to, by_time });
  const cid =
    categoryId != null && String(categoryId).trim() !== ''
      ? String(categoryId).trim()
      : undefined;
  const pid =
    productId != null && String(productId).trim() !== ''
      ? String(productId).trim()
      : undefined;
  const q =
    search != null && String(search).trim() !== ''
      ? String(search).trim()
      : undefined;

  return normalizeReportParams({
    ...base,
    categoryId: cid,
    category_id: cid,
    productId: pid,
    product_id: pid,
    sort,
    sortDir,
    sort_dir: sortDir,
    search: q,
    productTitle: q,
    page,
    perPage,
  });
}

/**
 * Commerce order reports: filter by string `order_status` (and legacy `statusName`
 * for older aggregations). When "include all" is on, only `includeAllStatuses` is sent.
 */
export function buildReportOrderStatusQuery({
  includeAllStatuses,
  reportOrderStatus,
} = {}) {
  if (includeAllStatuses) {
    return { includeAllStatuses: true };
  }
  const slug = canonicalOrderStatusKey(
    reportOrderStatus != null && String(reportOrderStatus).trim() !== ''
      ? reportOrderStatus
      : 'delivered',
  );
  return {
    order_status: slug,
    statusName: slug,
  };
}

